module.exports = __webpack_public_path__ + "static/img_9857-8d2a4c0d3afc123dc03545d76ef983b6.webp";